import type { EmbedThemeToken } from '@vellnes/composer-react';

import { ColorSchemeEnum } from '../../../../app/hooks/useTheme/useTheme';

// Mirrors the host's `bg-white dark:bg-gray-900` surface used around the
// composer embed (ComposerModalContent, ComposerRenderResultOverlay), so the
// widget's own UI and 3D viewport background blend into the same surface
// instead of showing as a mismatched rectangle against the app theme.
const LIGHT_SURFACE = '#ffffff';
const DARK_SURFACE = '#111827';

export interface ComposerThemeConfig {
  themeTokens: Partial<Record<EmbedThemeToken, string>>;
  sceneBackgroundColor: string;
}

function getComposerThemeConfig(
  colorScheme: ColorSchemeEnum
): ComposerThemeConfig {
  const isDark = colorScheme === ColorSchemeEnum.DARK;
  const surface = isDark ? DARK_SURFACE : LIGHT_SURFACE;

  return {
    themeTokens: {
      '--surface-page': surface,
      '--surface-panel': surface
    },
    sceneBackgroundColor: surface
  };
}

export default getComposerThemeConfig;
